import { useState, useEffect } from "react";
import { useGetAllInquiryLabelQuery } from "src/services/InquiryLabelServices";

const useInquiryLabels = () => {
  const [inquiryLabels, setInquiryLabels] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllInquiryLabelQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setInquiryLabels(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { inquiryLabels, isDataLoading };
};

export default useInquiryLabels;
